import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import MisionVision from "./components/MisionVision";
import Contacto from "./components/Contacto";
import EmpresasRamos from "./components/EmpresasRamos";
import NavBar from "./components/NavBar";
import ResponsiveCarousel from "./components/ResponsiveCarousel";
import Areas from "./components/Areas";
import SocialLinks from "./components/SocialLinks";
import Trabajos from "./components/Trabajos";
import VideoComp from "./components/VideoComp";
import Infancia from "./components/Infancia";
import Supervivencia from "./components/Supervivencia";
import Ninez from "./components/Ninez";
import Juventud from "./components/Juventud";
import DonacionesPage from "./components/DonacionesPage";
import Revista from "./components/Revista";
import CarrusellDonantes from "./components/CarrusellDonantes";
import Familias from "./components/Familias";

// Página principal
function HomePage() {
  return (
    <div className="bg-gradient-to-b from-black via-black to-gray-800 flex flex-col">
      <VideoComp />
      <ResponsiveCarousel />
      <MisionVision />
      <Areas />
      <Trabajos />
      <EmpresasRamos />
      <Revista/>
      <CarrusellDonantes/>
      <Contacto />
      <SocialLinks />
    </div>
  );
}

// Componente contenedor que decide si mostrar el navbar
function Layout() {
  const location = useLocation();
  // Lista de rutas donde NO queremos mostrar el NavBar
  const hideNavbarPaths = [
    "/infancia",
    "/supervivencia",
    "/ninez",
    "/juventud",
    "/donacionespage",
    "/familias",
  ];

  return (
    <>
      {/* Mostrar navbar solo si no estamos en /infancia */}
       {!hideNavbarPaths.includes(location.pathname) && <NavBar />}

      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/supervivencia" element={<Supervivencia />} />
        <Route path="/infancia" element={<Infancia />} />
        <Route path="/ninez" element={<Ninez />} />
        <Route path="/juventud" element={<Juventud />} />
        <Route path="/familias" element={<Familias />} />
        <Route path="/donacionespage" element={<DonacionesPage />} />

      </Routes>
    </>
  );
}

function App() {
  return (
    <BrowserRouter>
      <Layout />
    </BrowserRouter>
  );
}

export default App;
